import { createContext, useContext, useState } from "react";

type CartSheetContextType = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const CartSheetContext = createContext<CartSheetContextType | undefined>(
  undefined,
);

export function CartSheetProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <CartSheetContext.Provider value={{ isOpen, open, close, toggle }}>
      {children}
    </CartSheetContext.Provider>
  );
}

export function useCartSheet() {
  const context = useContext(CartSheetContext);
  if (context === undefined) {
    throw new Error("useCartSheet must be used within a CartSheetProvider");
  }
  return context;
}
